module.exports = __webpack_public_path__ + "img/SOUTHASIA_HIGH_GLYCEMIC.ce804afa.png";